const convertToPercentValue = (
  value: number | null,
  valueIfNull: string | number,
): number | string => {
  return value != null ? Number(value * 100) : valueIfNull;
};

const getPostfix = (value: number | null, postfix: string = "%") => {
  return value != null ? postfix : "";
};

const convertToIntegerValue = (
  value: number | null,
  valueIfNull: string | number,
): number | string => {
  return value != null ? Number(value) : valueIfNull;
};

export { convertToPercentValue, getPostfix, convertToIntegerValue };
